import { useNavigate } from 'react-router';

import { IconPlus } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { Container as DragAndDropContainer, Draggable } from 'react-smooth-dnd';

import { Button, Icon, Typography } from '@cfa/react-components';
import { Surface } from '@cfa/react-core';

import Constants from '@/constants';

import { handleDrop } from './actions';
import AddCategory from './AddCategory';

import CardCategory from '@/routes/Admin/components/CardCategory';
import { useCategories } from '@/routes/Admin/data';
import { setAdminState, useFocusAdminState } from '@/routes/Admin/state';

const Recommended: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data: recommended = [] } = useCategories(c => c.featured);
  const { addRecommendedCategoryOpen } = useFocusAdminState(
    'addRecommendedCategoryOpen',
  );
  const { selectedCountry } = useFocusAdminState('selectedCountry');

  return (
    <>
      <Typography className="mb-2 text-base/6 font-bold uppercase">
        {t('Admin.recommended')}
      </Typography>
      {recommended.length > 0 && (
        <div className="rounded-1.5 pathway-smooth-dnd-container w-full p-2.5">
          {/** @ts-expect-error it's yelling about children but we need children for the drag and drop */}
          <DragAndDropContainer
            dragHandleSelector=".recommend-drag-handle"
            dropPlaceholder={{
              className: 'shadow-on-drop',
            }}
            onDrop={e => handleDrop('recommended', e)}
          >
            {recommended.map((category, index) => (
              // @ts-expect-error it's yelling about children but we need children for the drag and drop
              <Draggable key={`${category.id}-${index}`}>
                <Surface className="pathway-surface" key={category.id}>
                  <CardCategory
                    category={category}
                    gripClassName="recommend-drag-handle text-base/6 font-medium"
                    onVisibilityPress={() => {
                      setAdminState('visibilityModalState', {
                        open: true,
                        isFeatured: true,
                        category,
                        categoryIndex: index,
                      });
                    }}
                    onDelete={() =>
                      setAdminState('deleteModalState', {
                        open: true,
                        isFeatured: true,
                        category,
                      })
                    }
                    onEdit={() => navigate(`/admin/categories/${category.id}`)}
                    onClickCategory={() => {}}
                    onSixDotMenuIconClick={() => {}}
                  />
                </Surface>
              </Draggable>
            ))}
          </DragAndDropContainer>
        </div>
      )}
      <Button
        color="secondary"
        onClick={() =>
          setAdminState('addRecommendedCategoryOpen', prev => !prev)
        }
        variant="text"
      >
        <Icon
          className="text-brand-navy mr-2 cursor-pointer"
          icon={IconPlus}
          size="sm"
        />
        <Typography
          color="secondary"
          data-testid="AddRecommendedCategory"
          variant="body1"
        >
          {t('Admin.addRecommended')}
        </Typography>
      </Button>
      {addRecommendedCategoryOpen && (
        <AddCategory
          isRecommended
          numberOfCategories={recommended.length}
          onCancel={() => setAdminState('addRecommendedCategoryOpen', false)}
          onClose={() => setAdminState('addRecommendedCategoryOpen', false)}
          selectedCountry={selectedCountry.label}
          translationNotRequired={[
            Constants.ADMIN_MANAGING_COUNTRIES.CA.LABEL_KEY,
            Constants.ADMIN_MANAGING_COUNTRIES.GB.LABEL_KEY,
            Constants.ADMIN_MANAGING_COUNTRIES.SG.LABEL_KEY,
          ].includes(selectedCountry.label)}
        />
      )}
    </>
  );
};

export default Recommended;
